import { render, staticRenderFns } from "./BlackListing.vue?vue&type=template&id=615c4ceb&scoped=true&"
import script from "./BlackListing.vue?vue&type=script&lang=js&"
export * from "./BlackListing.vue?vue&type=script&lang=js&"
import style0 from "./BlackListing.vue?vue&type=style&index=0&id=615c4ceb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615c4ceb",
  null
  
)

export default component.exports